import React, { useEffect, useRef, useState }   from "react";
import {Link}                           from "react-router-dom";
import {FontAwesomeIcon}    from "@fortawesome/react-fontawesome";

import "./orders.scss";

import {OmniSearchCarousel} from "../../omni-search-carousel/omni-search-carousel";
import {Order, WIDTH_ORDER} from "./order/order";

export const URL_ORDERS_HISTORY = '/account/orders/history'
const URL_ORDERS_PENDING = '/account/orders/pending'

const TABS = {
    PENDING: 0,
    HISTORY: 1
}

const EDGE_ITEM_DIVISOR = 5

export const Orders = ({
    addSearchHistoryRecord,
    apis,
    cart,
    company,
    orders,
    queryParam,
    routerHistory,
    session,
    deleteTargetOrder,
    setDeleteTargetOrder
}) => {
    const [ordersPending, setOrdersPending] = useState([])
    const [ordersHistory, setOrdersHistory] = useState([])
    const [tabActive, setTabActive] = useState(TABS.PENDING)

    useEffect(() => {
        const pending = orders.filter(order => order.status.includes('pending')) ?? []
        const history = orders.filter(order => order.status.includes('complete')) ?? []
        if((history.length < 1) ^ (pending.length < 1)) {
            if(tabActive === TABS.HISTORY && history.length < 1) {
                setTabActive(TABS.PENDING)
            }
            if(tabActive === TABS.PENDING && pending.length < 1) {
                setTabActive(TABS.HISTORY)
            }
        }

        setOrdersPending(pending)
        setOrdersHistory(history)
    }, [orders])

    const encodedParam = queryParam ? `?all=${encodeURI(queryParam)}` : ''
    const linkOrderHistory = `${URL_ORDERS_HISTORY}${encodedParam}`

    if(ordersPending.length < 1 && ordersHistory.length < 1) {
        return null
    }

    return (
        <div className="orders-odr381">
            <TabList>
                <Tab {...{
                    isClickable: ordersPending.length > 0,
                    text: "Pending Orders",
                    tab: TABS.PENDING,
                    tabActive,
                    setTabActive
                }}/>
                <Tab {...{
                    isClickable: ordersHistory.length > 0,
                    text: "Order History",
                    tab: TABS.HISTORY,
                    tabActive,
                    setTabActive
                }}/>
                <Link
                    to={`${tabActive === TABS.PENDING ? URL_ORDERS_PENDING : linkOrderHistory}`}
                    className="orders-link"
                >
                    View All Orders
                </Link>
            </TabList>
            {
                (ordersPending.length > 0 && tabActive === TABS.PENDING) &&
                <OmniSearchCarousel
                    Component={Order}
                    items={ordersPending}
                    widthComponent={WIDTH_ORDER}
                    edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                    additionalProps={{
                        apis, 
                        cart, 
                        company,
                        deleteTargetOrder, setDeleteTargetOrder,
                        routerHistory, 
                        session, 
                        items: ordersPending, setOrdersPending
                    }}
                />
            }
            {
                (ordersHistory.length > 0 && tabActive === TABS.HISTORY) &&
                <OmniSearchCarousel
                    Component={Order}
                    items={ordersHistory}
                    widthComponent={WIDTH_ORDER}
                    edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                    additionalProps={{addSearchHistoryRecord}}
                />
            }
        </div>
    )
}

const Tab = ({isClickable, text, tab, tabActive, setTabActive}) => {
    const selected = tab === tabActive ? 'selected' : ''
    const allowed = isClickable ? '' : 'not-allowed'

    return (
        <div 
            className={`tab ${selected} ${allowed}`}
            onClick={() => {
                if(!isClickable) {
                    return
                }
                setTabActive(tab)
            }}
            xd-qa-type="tab"
            xd-qa-name={text}
        >
            {text}
        </div>
    )
}

const TabList = ({children}:{children:React.ReactNode}) => (
    <div className="tab-list">
        {children}
    </div>
)